import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);
const HINT = "mk_client_session";

export function ClientAuthProvider({ children }) {
  const [client, setClientState] = useState(null);
  const [loading, setLoading] = useState(true);

  const setClient = useCallback((c) => {
    setClientState(c);
    if (c) localStorage.setItem(HINT, "1");
    else localStorage.removeItem(HINT);
  }, []);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/client/me");
      setClientState(r.data);
      localStorage.setItem(HINT, "1");
    } catch {
      setClientState(null);
      localStorage.removeItem(HINT);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    if (localStorage.getItem(HINT)) refresh();
    else setLoading(false);
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/client/logout"); } catch {}
    setClientState(null);
    localStorage.removeItem(HINT);
  };

  return <Ctx.Provider value={{ client, setClient, loading, refresh, logout }}>{children}</Ctx.Provider>;
}

export const useClientAuth = () => useContext(Ctx);
